module.exports = __webpack_public_path__ + "d2c8e769c8ad08dddb86a31a017ce68b.svg";